module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticClass: "abbre",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("AETH")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Asociación para la Educación Teológica Hispana")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("AG")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Assemblies of God")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("AHET")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Asociación Hispana para la Educación Teológica")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("AIC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Asamblea de Iglesias Cristianas")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("AMEN")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Alianza Ministerial Evangélica National")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("APHILA")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Academia para la Historia de la Iglesia Latinoamericana")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("ARIS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("American Religious Identification Survey")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("ATH")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Asociación Teológica Hispana")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("ATS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Association of Theological Schools")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("BGCT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Baptist General Convention of Texas")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("CARA")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Center for Applied Research in the Apostolate")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("CEHILA")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Comisión para el Estudio de La Historia de las Iglesias en América Latina y el Caribe")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("CIA")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Central Intelligence Agency")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("CLADIC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Concilio Latinoamericano de Iglesias Cristianas")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("CLANY")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Concilio Latinoamericano de la Iglesia de Dios Pentecostal de Nueva York")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("CLUE")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Clergy and Laity United for Economic Justice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("COGIC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Church of God in Christ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("CSO")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Community Service Organization")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("GSS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("General Social Surveys")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("HABBM")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Hispanic Association for Bilingual-Bicultural Ministries")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("HBCT")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Hispanic Baptist Convention of Texas")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("HCAPL")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Hispanic Churches in American Public Life")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }, [_vm._v("HMC")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Home Missions Council")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("HSP")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Hispanic Summer Program")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("HTI(C)")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Hispanic Theological Initiative (Consortium)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("LABI")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Latin American Bible Institute")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("LCMS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Lutheran Church–Missouri Synod")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("LPAC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Latino Pastoral Action Center")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("MAP")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Mexican American Program")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("MARCHA")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Metodistas Representando la Causa de los Hispanos Americanos")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("MB")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Mennonite Brethren")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("MEC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Methodist Episcopal Church")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("MECS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Methodist Episcopal Church, South")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("MI")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Iglesia de Dios Pentecostal, Movimiento Internacional")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("NAE")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("National Association of Evangelicals")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("NAFTA")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("North American Free Trade Agreement")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("NaLEC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("National Latino Evangelical Coalition")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("NCC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("National Council of Churches")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("NHCLC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("National Hispanic Christian Leadership Conference")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("PARAL")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Program for the Analysis of Religion among Latinos")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("PCUS")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Presbyterian Church, US")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("PCUSA")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Presbyterian Church (USA)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("PROLADES")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Programa Latinoamericano de Estudios Sociorreligiosos")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("SBC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Southern Baptist Convention")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("SDA")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("Seventh-Day Adventist Church")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("UFW")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("United Farm Workers")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("UMC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("United Methodist Church")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("UPC")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft2"
  }, [_vm._v("United Pentecostal Church")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-847bb512","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 75
// module chunks = 0